import { FormattedMessage as BaseFormattedMessage } from 'react-intl';

type FormattedMessageProps = {
  id?: string;
  defaultMessage?: string;
  description?: string;
};

const FormattedMessage: React.FunctionComponent<FormattedMessageProps> = (props: FormattedMessageProps) => {
  return <BaseFormattedMessage id={props.id} />;
};

export default FormattedMessage;
